export default __webpack_public_path__ + "static/media/send-disabled.931d2e36.svg";